<template>
    <div class="d-flex align-items-center ">
        <div class="langtoggle">
            <LanguageSwitch></LanguageSwitch>
        </div>
        <div v-if="coverImage !== ''" class="header-cover" :style="{
            'background-image': `url('${coverImage}')`,
            width: '100%',
            'background-size': 'cover',
            'background-position': 'center center',
        }"></div>
        <CCard class="p-3 card-home" :style="{ top: cardTop }">
            <CCardBody class="text-center">
                <div style="display: flex; justify-content: center;">
                    <div class="logoImg" :style="{
                        'background-image': `url('${logo}'), url('${noImg}')`,
                        'background-size': 'cover',
                        'background-position': 'center center',
                    }"></div>
                </div>
                <h2 class="font-weight-bold mt-3">
                    {{ shopName }}
                </h2>
                <h6 class="text-grey mb-4">{{ branchName }} </h6>

                <CButton :disabled="loading" class="mt-5 btn-startorder p-3 " style=" font-size: 20px;color: white;"
                    block @click="startOrder()">
                    <CSpinner v-if="loading" class="mb-1" component="span" size="sm" aria-hidden="true" /> &nbsp;
                    {{ $t('startOrder') }}
                </CButton>
                <CButton :disabled="loading" v-if="!isDeliveryLogin" class="mt-2 btn-login-home p-3 " style=" font-size: 20px;"
                    block @click="goToLogin()">
                    <CSpinner v-if="loading" class="mb-1" component="span" size="sm" aria-hidden="true" /> &nbsp;
                    {{ $t('login') }}
                </CButton>
                <!-- <CButton :disabled="loading" v-else class="mt-2 btn-login-home p-3 " style=" font-size: 20px;"
                    block data-toggle="modal"
                    data-target="#logout-modal">
                    <CSpinner v-if="loading" class="mb-1" component="span" size="sm" aria-hidden="true" /> &nbsp;
                    {{ $t('signOut') }}
                </CButton> -->


                <div class="mt-5">
                    <span>
                        Powered by
                        <img src="/logo.png" width="30%" alt="" class="img-fluid ml-1" />
                    </span>
                </div>
            </CCardBody>
        </CCard>
        <div class="modal fade small-modal" id="logout-modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content p-4">
                    <div class="modal-body d-flex align-items-center justify-content-center text-center flex-column">
                        <h1 class="pt-2"> <i class="fi fi-rs-sign-out-alt"></i></h1>
                        <h4 class="mt-3 text-center">{{ $t('dialogSignOut') }}</h4>
                    </div>
                    <div class="modal-footer p-0 d-flex  justify-content-center mt-3">
                        <button style="width: 45%;border-radius: 60px;" @click="showModal = false" type="button"
                            class="btn h4 btn-secondary " data-dismiss="modal">{{
                                $t('cancel') }}</button>
                        <button style="width: 45%;border-radius: 60px;" type="button" class="btn h4 btn-danger"
                            @click="logout()" data-dismiss="modal">{{ $t('confirm') }}</button>
                    </div>
                </div>
            </div>
        </div>
        <img class="bg-decorate" src="/bg-decorate.png" alt="Decorative Background">
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import poscrm from '@/services/poscrm'
import '@/util/menu.css'
import '@/util/delivery.css'
import LanguageSwitch from '@/components/AppLanguageSwitch'
import util from '@/util/util.js'

export default {
    components: {
        LanguageSwitch
    },
    data() {
        return {
            table: {},
            receiptId: '',
            receiptObjectId: '',
            callStaffModal: false,
            showDropdown: false,
            coverImage: '',
            cartLists: [],
            loading: false,
            screenWidth: window.innerWidth,
            dangerModal: false,
            footer: '',
            loadingButton: true,
        }
    },
    computed: {
        ...mapGetters(['shopLineOA']),
        cardTop() {
            return `${this.screenWidth / 5}px`;
        },
        token() {
            return localStorage.getItem('token') || null
        },
        uid() {      
            let uid = this.$route.query.uid || localStorage.getItem('uid')
            localStorage.setItem('uid', uid)
            return uid
        },
        shopObjectId() {
            let objectId = this.$route.query.shopObjectId || localStorage.getItem('shopObjectId')
            localStorage.setItem('shopObjectId', objectId)
            return objectId
        },

        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        shopName() {
            if (this.shop) {
                localStorage.setItem('shopName', this.shop.shopName)
                return this.shop.shopName
            } else {
                return ''
            }
        },
        logo() {
            const shop = this.shop || {}
            if (shop.remoteImagePath != undefined) {
                return shop.remoteImagePath
            } else {
                return 'https://cdn-icons-png.flaticon.com/512/4711/4711299.png'
            }
        },
        branchName() {
            if (this.shop) {
                return this.shop.branchName
            } else {
                return ''
            }
        },

        noImg() {
            return process.env.VUE_APP_NOIMAGE
        },
        isDeliveryLogin() {
            return !!localStorage.getItem('token')
        },
    },
    beforeCreate() {
        this.$store.dispatch('getShopLineOA')
        this.cartLists = JSON.parse(sessionStorage.getItem('cart')) || []
        if (this.cartLists.length == 0) {
            sessionStorage.clear()
        }
    },
    created() {
        const { uid, shopObjectId } = this.$route.query;
        if (!uid || !shopObjectId) {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    uid: uid || this.uid,
                    shopObjectId: shopObjectId || this.shopObjectId
                }
            });
        }

        // Detect LINE LIFF WebView and redirect to /delivery/user
        const isLineLiff = /Line|LIFF/i.test(navigator.userAgent)
        if (isLineLiff) {
            window.location.href = '/delivery/user'
            return
        }

        this.getOrderShopSetting()
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        ...util,
        logout() {
            const uid = localStorage.getItem('uid')
            const shopObjectId = localStorage.getItem('shopObjectId')
            sessionStorage.clear()
            localStorage.clear()
            localStorage.setItem('uid', uid)
            localStorage.setItem('shopObjectId', shopObjectId)
            // this.$router.push('/delivery/home')
        },
        goToLogin() {
            this.$router.push('/delivery/user')
        },
        trackButtonClick(buttonLabel) {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'click', {
                    event_label: buttonLabel,
                });
            } else {
                console.error('gtag is not defined.');
            }
        },
        handleResize() {
            this.screenWidth = window.innerWidth;
        },
        setPathAsShopName() {
            this.$router.replace({
                path: this.$route.path,
            });
        },
        async getOrderShopSetting() {
            const uid = this.uid
            const shopObjectId = this.shopObjectId

            let params = {
                shopObjectId: shopObjectId,
            }
            try {
                await poscrm({
                    method: 'get',
                    url: '/api/v2.1/' + uid + '/OrderShopSetting',
                    params: params,
                }).then((res) => {
                    this.coverImage = res.data?.data?.[0]?.remoteCoverImagePath || '';
                    const themeColor = res.data?.data[0]?.themeColor || '#29B46B'
                    $(':root').css('--bg-color-theme', themeColor);

                    // Store languageConfig for LanguageSwitch
                    const langConfig = res.data?.data?.[0]?.languageConfig || null
                    
                    if (langConfig) {
                        localStorage.setItem('languageConfig', JSON.stringify(langConfig))
                    } else {
                        const defaultConfig = { enabledLanguages: { th: true, en: true }, fallbackType: 'SKUName', fallbackLanguage: 'th' }
                        localStorage.setItem('languageConfig', JSON.stringify(defaultConfig))
                    }
                    this.setPathAsShopName()
                })
            } catch (error) {
                throw new Error(error)
            }
        },
        changeLocale(locale) {
            this.$i18n.locale = locale
            this.showDropdown = false
            this.trackButtonClick('home/change_lang_to_' + locale)
        },

        startOrder() {
            this.trackButtonClick('home/open_table')
            this.loading = true
            // let profile = localStorage.getItem('profile') || null
            // this.$router.push('/delivery/menulists')
            window.location.href = '/delivery/menulists'
            this.loading = false
            // if (this.token !== null && profile !== null) {
            //     this.$router.push('/delivery/menulists')
            //     this.loading = false
            // } else {
            //     localStorage.removeItem('token')
            //     this.$router.push('/delivery/user')
            //     this.loading = false
            // }
        },
    },
}
</script>

<style>
.logoImg {
    background-color: rgb(255, 255, 255);
    width: 50%;
    aspect-ratio: 1/1;
    border-radius: 50%;
}

.header-cover {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    aspect-ratio: 2/1;

    /* Set height to 50% of width */
}

.langtoggle {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1050;
    padding: 20px;
}

.card {
    background-color: unset;
    border: 0cap;
    overflow-y: scroll;
}

.card-home {
    z-index: 1000;
}
</style>
